import React, { useState, useEffect } from 'react';
import { WhatsAppIcon } from 'components';
import { GetBrandPublicService, GetStoreListService, GetIpAddress } from 'services';

import './public.scss';
import AvatarArezzo from 'img/placeholder-avatar.jpg';
export const PublicPage = () => {
  const [brandDataList, setBrandDataList] = useState([]);

  let hash = window.location.hash;
  const [storesList, setStoresList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [uf, setUf] = useState('');
  const [avatarImage, setAvatarImage] = useState('');
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState('');

  useEffect(() => {
    GetBrandPublicService().then((response) => {
      if (!response) return;
      setStatesList(response?.statesAvailable);
      setAvatarImage(response.avatarImage);
      setBrandDataList(response);
    });

    GetIpAddress().then((response) => {
      if (!response) return;
      if (isRoot()) setUf(response);
    });

    if (getUFByURL() && !isRoot()) setUf(getUFByURL());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (validateEmptyParam(uf)) {
      GetStoreListService(uf, city).then((response) => {
        if (!response) return;
        setStoresList(response.storeList);
        const notEmptyCityName = response.cities.filter((city) => city.name);
        setCities(notEmptyCityName);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uf]);

  const isRoot = () => {
    return hash === "#/" ? true : false;
  }

  const validateEmptyParam = (param) => {
    return param.length;
  }

  const getUFByURL = () => {
    let path = hash.split("/").pop();
    path = path.toUpperCase();
    const allUFs = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"];
    if (allUFs.includes(path)) {
      return path;
    }

  }

  useEffect(() => {
    if (validateEmptyParam(city)) {
      GetStoreListService(uf, city).then((response) => {
        if (!response) return;
        setStoresList(response.storeList);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  const handleChangeState = (event) => {
    setUf(event.target.value);
    setCity([]);
  };

  const handleChangeCity = (event) => {
    setCity(event.target.value);
  };

  const renderItems = () => {
    return storesList.map((store, index) => {
      return (
        <li
          key={index}
          className="bg-white shadow mb-5 p-4 bg-white rounded overflow-hidden"
        >
          <div className="d-flex align-items-center mb-2">
            <img
              className="public-area__avatar mr-3 rounded-circle"
              src={avatarImage || AvatarArezzo}
              alt={store.name}
              width="60px"
            />
            <div>
              <strong>{store.name}</strong>
              <p className="text-secondary mb-0">{store.address}</p>
            </div>
          </div>
          <a
            href={store.link}
            target="_blank"
            rel="noreferrer noopener"
            className="btn btn-primary btn-block rounded-pill px-5"
          >
            <WhatsAppIcon />
            WhatsApp
          </a>
        </li>
      );
    });
  };

  const renderCityes = () => {
    return cities.map((city, index) => {
      return (
        <option key={index} value={city.name}>
          {city.name.toUpperCase()}
        </option>
      );
    });
  };

  const renderStatesList = () => {
    return statesList.map((state, index) => {
      return (
        <option key={index}> {state} </option>
      );
    })
  }

  return (
    <div className="public-area container rounded-lg">
      <img
        className="public-area__brand pb-2"
        src={brandDataList.logoImage}
        alt="Whatsapp Business Arezzo&co"
      />
      <p>{brandDataList.phrase}</p>
      <div className="form-group">
        <select
          className="form-control"
          value={uf}
          onChange={(event) => handleChangeState(event)}
        >
          <option>Selecione um Estado..</option>
          {renderStatesList()}
        </select>
      </div>
      {cities && (
        <div className="form-group">
          <select
            className="form-control"
            value={city.name}
            onChange={(event) => handleChangeCity(event)}
          >
            <option>Selecione a Cidade ...</option>
            {renderCityes()}
          </select>
        </div>
      )}
      {brandDataList.bannerImage && (
        <a
          href={brandDataList.linkBanner}
          rel="noreferrer noopener"
          target="_blank"
          className="d-flex shadow my-3 bg-white rounded overflow-hidden"
        >
          <img
            width="100%"
            src={brandDataList.bannerImage}
            alt={brandDataList.linkBanner}
          />
        </a>
      )}
      <ul className="p-0">{storesList && renderItems()}</ul>
    </div>
  );
};
